import { SxProps } from "@mui/material";
import theme, { fontFamily } from "@/theme";

export const styles: Record<string, SxProps> = {
  wrapper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "519px",
    backgroundColor: "#FFFFFF",
    borderRadius: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
    boxShadow: "0px 32px 48px -8px rgba(0,0,0,0.10), 0px 0px 14px -4px rgba(0,0,0,0.05)",
  },
  content: {
    padding: "0px 64px 40px 64px",
  },
  logoBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "12px",
  },
  title: {
    fontFamily: fontFamily.inter,
    fontWeight: 600,
    fontSize: "28px",
    lineHeight: "36px",
    textAlign: "center",
    marginBottom: "6px",
    color: "#000000",
  },
  subtitle: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#7D8690",
    marginBottom: "52px",
  },
  inputWrapper: {
    width: "100%",
    marginBottom: "24px",
  },
  label: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#2A2D31",
    marginBottom: "10px",
  },
  input: {
    width: "391px",
    height: "54px",
    borderRadius: "999px",
    caretColor: "#5b87f8",

    "& input:-webkit-autofill": {
      boxShadow: "0 0 0px 1000px #fff inset",
      WebkitTextFillColor: "#383C40",
      borderRadius: "999px",
      caretColor: "#5b87f8",
      transition: "background-color 5000s ease-in-out 0s",
    },

    "& .MuiOutlinedInput-root": {
      padding: 0,
      paddingLeft: "24px",
      paddingRight: "24px",
      borderRadius: "999px",
      backgroundColor: "#fff",
      boxShadow: "none",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
        borderWidth: "1px",
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E0E0E9",
      },

      // error
      "&.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: "#FF403D",
      },
    },

    "& input": {
      padding: 0,
      fontFamily: fontFamily.inter,
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "150%",
      color: "#383C40",

      "::placeholder": {
        color: "#C6CACE",
      },
    },
  },

  inputText: {
    height: "100%",
    padding: 0,
    display: "flex",
    alignItems: "center",
  },

  button: {
    width: "390px",
    height: "54px",
    borderRadius: "28px",
    padding: "18px 0",
    backgroundColor: theme.palette.custom.mainBlue,
    color: "#FFFFFF",
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "18px",
    textTransform: "none",
    marginTop: "18px",

    "&.Mui-disabled": {
      backgroundColor: "#8BC5F4",
      color: "#FFFFFF",
    },
  },
  back: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "54px",
    width: "100%",
    paddingTop: "15px",
    paddingLeft: "16px",
    cursor: "poinnter",
  },
  forgotPassword: {
    textAlign: "right",
    color: theme.palette.custom.mainBlue,
    textDecoration: "underline",
    fontFamily: fontFamily.inter,
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    cursor: "pointer",
    marginTop: "8px",
  },

  blurLayer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    zIndex: 2,
  },

  loaderContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3,
  },
  loaderIcon: {
    animation: "spin 1s linear infinite",
    "@keyframes spin": {
      from: { transform: "rotate(0deg)" },
      to: { transform: "rotate(360deg)" },
    },
  },
  resend: {
    fontFamily: fontFamily.inter,
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#52575D",
    padding: "47px 0 8px 0",
  },

  resendLink: {
    fontWeight: 500,
    color: theme.palette.custom.mainBlue,
    textDecoration: "underline",
    cursor: "pointer",
  },

  header: {
    width: "100%",
    height: 58,
    position: "relative",
    display: "flex",
    alignItems: "center",
  },

  backButton: {
    position: "absolute",
    left: 16,
    width: 24,
    height: 24,
    padding: "2px",
  },

  logoWrapper: {
    mx: "auto",
    width: 147,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
